import React, { createContext, useContext, useState } from 'react';

// Create the context
export const ThemeModeContext = createContext({
  themeMode: 'system',
  setThemeMode: () => {},
});

// Custom hook for easy usage
export const useThemeMode = () => useContext(ThemeModeContext);

// Provider component
export const ThemeModeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState('system');
  return (
    <ThemeModeContext.Provider value={{ themeMode, setThemeMode }}>
      {children}
    </ThemeModeContext.Provider>
  );
};